module.exports = __webpack_public_path__ + "static/media/icon_nagidebf1cffa2299408be69ae247b8f40b6.webp";